package com.ives.utils;

import js.Browser;
import js.html.NodeList;
import js.html.Element;

@:build(com.ives.utils.TranslationBuilderMacro.build())
class Translator {
	public static var currentLanguage:String;

	public static inline var TRANSLATION_MISSING = "Translation missing";
	public static inline var TR_ATTR:String = "data-tr";
	public static inline var TR_TITLE_ATTR:String = "data-tr-title";
	public static inline var TR_ALL:String = "data-tr-all";
	public static inline var TITLE_ATTR:String = "title";

	public static function translate(?element:Element){
		var nodes:NodeList;

		if(element == null)
			nodes = Browser.document.querySelectorAll('*[${TR_ATTR}], *[${TR_TITLE_ATTR}], *[${TR_ALL}]');
		else
			nodes = element.querySelectorAll('*[${TR_ATTR}], *[${TR_TITLE_ATTR}]');

		for(node in nodes){
			var element:Element = cast node;

			if(element.hasAttribute(TR_ATTR))
				element.innerHTML = getTransltaion(element.getAttribute(TR_ATTR));

			if(element.hasAttribute(TR_TITLE_ATTR))
				element.title = getTransltaion(element.getAttribute(TR_TITLE_ATTR));

			if(element.hasAttribute(TR_ALL)){
				element.innerHTML = getTransltaion(element.getAttribute(TR_ALL));
				element.title = getTransltaion(element.getAttribute(TR_ALL));
			}
		}
	}

	public static function getTransltaion(key:String):String{
		if(translations.get(currentLanguage) == null)
			return TRANSLATION_MISSING;

		var translation:String = translations.get(currentLanguage).get(key);

		if(translation == null)
			return TRANSLATION_MISSING;

		return translation;
	}

	public static function traslateTo(lang:String){
		Log.debug('Translating to language: "${lang}"');

		currentLanguage = lang;

		translate();
	}
}
